import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface InteriorTrimsDoorsAndMirrorsDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const InteriorTrimsDoorsAndMirrorsDescription: React.FC<InteriorTrimsDoorsAndMirrorsDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [interiorTrimsDoorsAndMirrors, set_interiorTrimsDoorsAndMirrors] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Interior Trims, Doors, and Mirrors']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Interior Trims, Doors, and Mirrors': [v, b.values?.['Interior']?.['Interior Trims, Doors, and Mirrors']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={interiorTrimsDoorsAndMirrors}
                />
            ) : (
                <TextBox
                    value={interiorTrimsDoorsAndMirrors}
                    onChange={(value) => set_interiorTrimsDoorsAndMirrors(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
